import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { DokumenKerjasamaRequest } from "../../interfaces/DokumenKerjasama";

const validateDokumenKerjasama = (payload: DokumenKerjasamaRequest): ErrorResponse => {
  let errors: ErrorResponse = {
    name: '',
    message: '',
    code: 422,
    status: 422,
    data: []
  };

  if (!payload.DOK_DESCR) {
    errors.data?.push({
      field: "DOK_DESCR",
      message: "Deskripsi dokumen wajib diisi"
    });
  }

  if (!payload.DOK_JENIS_ID || !payload.DOK_JENIS_DETAIL) {
    errors.data?.push({
      field: "DOK_JENIS_ID",
      message: "Jenis dokumen wajib dipilih"
    });
  } else {
    if (!payload.DOK_NOMOR_INDUK && payload.DOK_JENIS_DETAIL.DOK_JENIS_PARENT) {
      errors.data?.push({
        field: "DOK_PARENT_ID",
        message: "Nomor dokumen induk wajib diisi karena Anda memilih jenis dokumen yang memiliki nomor induk"
      });
    }
  }

  if (!payload.DOK_JUDUL_KERJASAMA) {
    errors.data?.push({
      field: "DOK_JUDUL_KERJASAMA",
      message: "Judul kerjasama dokumen wajib diisi"
    });
  }

  if (!payload.DOK_NOMOR) {
    errors.data?.push({
      field: "DOK_NOMOR",
      message: "Nomor dokumen wajib diisi"
    });
  }

  if (!payload.EMP_ID) {
    errors.data?.push({
      field: "EMP_ID",
      message: "PIC UMN wajib diisi"
    });
  }

  if (!payload.STATUS_ID) {
    errors.data?.push({
      field: "STATUS_ID",
      message: "Status kerjasama wajib diisi"
    });
  }

  if (payload.CO_ID.length === 0) {
    errors.data?.push({
      field: "CO_ID",
      message: "Partner kerjasama wajib diisi"
    });
  }

  if (payload.DEPT_ID.length === 0) {
    errors.data?.push({
      field: "DEPT_ID",
      message: "Pelaksana kerjasama wajib diisi"
    });
  }

  if (payload.KERMA_ID.length === 0) {
    errors.data?.push({
      field: "KERMA_ID",
      message: "Bentuk kerjasama wajib diisi"
    });
  }

  if (payload.ANGGOTA.length === 0) {
    errors.data?.push({
      field: "ANGGOTA",
      message: "Anggota wajib diisi"
    });
  }
  
  return errors;
}

export default validateDokumenKerjasama;